
import AboutusBanner from '../../../../assets/images/about-img-1.jpg'
import AboutImg727 from "../../../../assets/images/about-img-1.jpg";
import AboutImg260 from "../../../../assets/images/about-img-1-260x300.jpg";
import AboutImg370 from "../../../../assets/images/about-img-1-370x426.jpg";
import AboutImg410 from "../../../../assets/images/about-img-1-410x473.jpg";
import AboutImg600 from "../../../../assets/images/about-img-1-600x692.jpg";

import AboutImg2_716 from "../../../../assets/images/about-img-2.jpg";
import AboutImg2_300 from "../../../../assets/images/about-img-2-300x230.jpg";
import AboutImg2_370 from "../../../../assets/images//about-img-2-370x283.jpg";
import AboutImg2_410 from "../../../../assets/images/about-img-2-410x314.jpg";
import AboutImg2_600 from "../../../../assets/images/about-img-2-600x459.jpg";

const AboutusSection = () => {
    return (
        <>
        <section
      className="elementor-section elementor-top-section elementor-element elementor-element-0cbd599 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
      data-id="0cbd599"
      data-element_type="section"
    >
      <div className="elementor-container elementor-column-gap-extended">
        <div
          className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-f7c8e03 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
          data-id="f7c8e03"
          data-element_type="column"
        >
          <div className="elementor-widget-wrap elementor-element-populated">
            {/* Tiny spacer (hidden on mobile) */}
            <div
              className="elementor-element elementor-element-762ad19 sc_height_tiny sc_layouts_hide_on_mobile sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="762ad19"
              data-element_type="widget"
              data-widget_type="spacer.default"
            >
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>

            {/* Huge spacer */}
            <div
              className="elementor-element elementor-element-ab8d518 sc_height_huge sc_fly_static elementor-widget elementor-widget-spacer trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited"
              data-id="ab8d518"
              data-element_type="widget"
              data-widget_type="spacer.default"
            >
              <div className="elementor-widget-container">
                <div className="elementor-spacer">
                  <div className="elementor-spacer-inner"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
        <section className="elementor-section elementor-top-section elementor-element elementor-element-553307f1 elementor-section-boxed elementor-section-height-default elementor-section-height-default sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="553307f1" data-element_type="section" data-settings="{&quot;background_background&quot;:&quot;classic&quot;}">
            <div className="elementor-container elementor-column-gap-extended">
                <div className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3a76c3b8 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="3a76c3b8" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                         <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-7cd3741 no-title sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="7cd3741" data-element_type="widget" data-widget_type="image.default">
                    <div className="elementor-widget-container">
                      <img
                        loading="lazy"
                        decoding="async"
                        width={727}
                        height={838}
                        src={AboutusBanner}
                        className="attachment-full size-full wp-image-18148"
                        alt="About Modli 3D"
                        srcSet={`
    ${AboutImg260} 260w,
    ${AboutImg370} 370w,
    ${AboutImg410} 410w,
    ${AboutImg600} 600w,
    ${AboutImg727} 727w
  `}
                        sizes="(max-width: 727px) 100vw, 727px"
                      />

                    </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-5de08b73 sc_content_align_inherit sc_layouts_column_icons_position_left sc_fly_static trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="5de08b73" data-element_type="column">
                    <div className="elementor-widget-wrap elementor-element-populated">
                        <div className="elementor-element elementor-element-4a3d2005 sc_fly_static elementor-widget elementor-widget-trx_sc_title trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="4a3d2005" data-element_type="widget" data-widget_type="trx_sc_title.default">
                            <div className="elementor-widget-container">
                                <div className="sc_title sc_title_default">
                                    <span className="sc_item_subtitle sc_title_subtitle sc_item_subtitle_above sc_item_title_style_default">our story</span>
                                    <h1 className="sc_item_title sc_title_title sc_item_title_style_default sc_item_title_tag">
                                        <span className="sc_item_title_text">About Our Company</span>
                                    </h1>
                                    <div className="sc_item_descr sc_title_descr">
                                    <p>
  We believe imagination has no borders. At <strong>Modli 3D</strong>, we help creators, businesses, and innovators worldwide bring their ideas to life through <strong>custom 3D printing services</strong>. From early-stage concepts to production-ready parts, we combine modern 3D printing technology with hands-on expertise to deliver reliable, high-quality results—no matter where you are.
</p>

                                        <p style={{marginBottom:'40px'}}>Our approach goes beyond simply printing files. We focus on understanding intent, function, and finish, ensuring every product is thoughtfully designed, tested, and built to perform in the real world.</p>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                <div className="elementor-element elementor-element-7cd3741 no-title sc_fly_static elementor-widget elementor-widget-image trx_addons_parallax_layers_inited trx_addons_parallax_blocks_inited" data-id="7cd3741" data-element_type="widget" data-widget_type="image.default">
                  <div className="elementor-widget-container">
                  <img
  loading="lazy"
  decoding="async"
  width={716}
  height={548}
  src={AboutImg2_716}
  className="attachment-full size-full wp-image-18149"
  alt="About Modli 3D – 3D Printing Services"
  srcSet={`
    ${AboutImg2_300} 300w,
    ${AboutImg2_370} 370w,
    ${AboutImg2_410} 410w,
    ${AboutImg2_600} 600w,
    ${AboutImg2_716} 716w
  `}
  sizes="(max-width: 716px) 100vw, 716px"
/>

                  </div>
                </div>
                    </div>
                </div>
            </div>
        </section></>
    );
};

export default AboutusSection;
